
import Producer from '@/components/buildings/Producer.vue'
import Storage from '@/components/buildings/Storage.vue'

export default {
  Producer,
  Storage
}



// WEBPACK FOOTER //
// ./src/components/buildings/index.js